import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lp-calculator-call-to-action" }
const _hoisted_2 = { class: "lp-cta__content" }
const _hoisted_3 = { class: "lp-cta-content__text" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.buttonText != '')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: _normalizeClass(`btn btn-${_ctx.buttonClass} btn-round`),
            href: _ctx.buttonLink,
            target: "_blank",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.buttonText), 11, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}